<template>
  <div class="gsap-card">
    <div class="card" :style="{ backgroundColor: item.bgcolor }">
      <div class="card-header">
        <div class="title">
          {{ item.title }}
          <span v-if="item.comingSoon" class="coming-soon">{{ soonText }}</span>
        </div>
        <div class="desc" v-html="item.desc"></div>
        <a :title="item.linkDesc" v-if="item.link" class="for-more" @click.stop="handleOpenLink">
          {{ moreText }}
          <ArrowRight filled class="for-more__arrow" />
        </a>
      </div>
      <Resource class="card-img" :src="item.img" :alt="item.imgAlt" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
const props = withDefaults(
  defineProps<{
    item: any;
    soonText?: string;
    moreText?: string;
  }>(),
  {
    soonText: '敬请期待',
    moreText: '了解更多',
  },
);

const handleOpenLink = () => {
  if (props.item.link) {
    window.open(props.item.link, '_blank');
  }
};
</script>

<style lang="scss" scoped src="./styles/powerful-card-pc.scss" />
<style lang="scss" scoped src="./styles/powerful-card-mobile.scss" />
